var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0268 5.2902L5.25781 17.3254L19.4935 29.3267C20.9154 30.5255 22.9942 30.5255 24.4161 29.3267L38.6518 17.3254L24.8828 5.2902C23.206 3.82449 20.7036 3.82449 19.0268 5.2902Z",
    fill: "url(#paint0_linear_1433_48248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.899 28.8243L5.2591 17.3252C4.69963 17.8466 4.34766 18.5877 4.34766 19.4128V37.3449C4.34766 38.2111 4.73472 38.9855 5.34362 39.5093L19.844 29.4408C19.5119 29.2754 19.1934 29.0724 18.899 28.8243Z",
    fill: "#7BBEE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5628 37.3449V19.4128C39.5628 18.5877 39.2108 17.8466 38.6513 17.3252L25.0114 28.8243C24.717 29.0724 24.3985 29.2754 24.0664 29.4408L38.5668 39.5093C39.1757 38.9855 39.5628 38.2111 39.5628 37.3449Z",
    fill: "#7BBEE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0682 29.4407L21.9562 27.9741L19.8441 29.4407L5.34375 39.5092C5.84366 39.9392 6.4926 40.2007 7.20376 40.2007H36.7087C37.4198 40.2007 38.0687 39.9392 38.5687 39.5092L24.0682 29.4407Z",
    fill: "#298AFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_48248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3351 22.2394C24.3716 22.9738 23.1984 23.3807 21.9871 23.4005C18.0416 23.4005 15.7871 18.8914 15.7871 18.8914C16.4882 17.5848 17.4606 16.4433 18.6391 15.5434M20.8034 14.5176C21.1914 14.4268 21.5886 14.3814 21.9871 14.3823C25.9325 14.3823 28.187 18.8914 28.187 18.8914C27.8449 19.5315 27.4369 20.1341 26.9696 20.6894M23.182 20.0863C23.0272 20.2524 22.8405 20.3857 22.6331 20.4781C22.4257 20.5705 22.2018 20.6202 21.9747 20.6242C21.7477 20.6282 21.5222 20.5865 21.3116 20.5014C21.1011 20.4164 20.9098 20.2898 20.7492 20.1292C20.5887 19.9687 20.4621 19.7774 20.3771 19.5669C20.292 19.3563 20.2503 19.1308 20.2543 18.9038C20.2583 18.6767 20.308 18.4528 20.4004 18.2454C20.4928 18.038 20.626 17.8513 20.7922 17.6965",
    stroke: "white",
    strokeWidth: 1.39899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7871 12.6914L28.187 25.0913",
    stroke: "white",
    strokeWidth: 1.39899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_48248",
    x1: 21.9548,
    y1: 4.19092,
    x2: 21.9548,
    y2: 30.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_48248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5272,
    height: 13.5272,
    fill: "white",
    transform: "translate(15.2246 12.1279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon10);
export default __webpack_public_path__ + "static/media/mail_card_icon10.6b9ad9c8147f7a0fa03e42dd3068e9b5.svg";
export { ForwardRef as ReactComponent };